import { resolvePaymentTerms } from './paymentTermsService.js';
import { format, parseISO, isValid } from 'date-fns';
/**
 * Enriches an extraction result with resolved payment terms (due date,
 * discount %, discount expiration) so the UI can display them immediately
 * after extraction — not only after save.
 */
export function enrichExtractionWithTerms(result) {
    const { data } = result;
    if (!data.payment_terms || !data.invoice_date)
        return result;
    try {
        const invoiceDate = parseISO(data.invoice_date);
        if (!isValid(invoiceDate))
            return result;
        const resolved = resolvePaymentTerms(data.payment_terms, invoiceDate);
        return {
            ...result,
            data: {
                ...data,
                // AI-extracted due_date takes precedence
                due_date: data.due_date || format(resolved.dueDate, 'yyyy-MM-dd'),
                discount: resolved.discountPercent || undefined,
                discount_expiration: resolved.discountPercent
                    ? format(resolved.discountExpirationDate, 'yyyy-MM-dd')
                    : undefined,
            },
        };
    }
    catch {
        // Payment terms didn't parse — return unchanged
        return result;
    }
}
//# sourceMappingURL=enrichExtractionWithTerms.js.map